




































import { Component, Mixins } from "vue-property-decorator";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "cprod-about-component": () =>
      import(`@/components/app/global/contractProducts/cProdAboutComp.vue`),
    "cprod-assistance-component": () =>
      import(
        `@/components/app/global/contractProducts/cProdAssistanceComp.vue`
      ),
    "cprod-details-component": () =>
      import(
        `@/components/app/global/contractProducts/cProdDetailsListComp.vue`
      ),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      ),
    "cprod-notices-component": () =>
      import(`@/components/app/global/contractProducts/cProdNoticesComp.vue`),
    "cprod-prov-actions-component": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvActionsComp.vue"
      ),
    "cprod-prov-details-component": () =>
      import(
        `@/components/app/global/contractProducts/cProdProvConfigDetailsComp.vue`
      ),
    "cprod-notes-component": () =>
      import("@/components/app/global/contractProducts/cProdNotesComp.vue"),
    "cprod-secrets-component": () =>
      import("@/components/app/global/contractProducts/cProdSecretsComp.vue")
  }
})
export default class UpmindClientCProdOverviewView extends Mixins(
  CProdInjectorMixin
) {
  // Computed
  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.CONTRACT_PRODUCT_OVERVIEW,
      objectId: this.cProdData.contractProductId
    };
  }

  public get isNotFullHd() {
    return !this.$store.getters["ui/isFullHd"];
  }

  private mounted() {
    this.$bus.$emit("scrollClientCProdView");
  }
}
